import toast from 'react-hot-toast'
import { Button } from 'components/common'
import { DownloadIcon } from 'components/icons'
import { downloadOrdersLogs } from 'utils/api/logsApi'

const OrdersLogExportButton = () => {
  const downloadCsv = async () => {
    const loadingToast = toast.loading('Loading..')
    try {
      await downloadOrdersLogs()
      toast.success('File will be sent to you in email!', { id: loadingToast })
    } catch (error) {
      toast.error('File Downloading Failed.', { id: loadingToast })
    }
  }

  return (
    <div className="mb-5">
      <Button
        buttonText="Export"
        className="w-40 px-0"
        icon={<DownloadIcon />}
        onClick={downloadCsv}
      />
    </div>
  )
}

export default OrdersLogExportButton
